import React, { useState, useEffect, useRef } from "react";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { SlButton } from "@shoelace-style/shoelace/dist/react";
import { SlProgressBar } from "@shoelace-style/shoelace/dist/react";
import Way2NewsLogo from '../../assets/images/way2news.png'
// development
// const socket = io.connect("http://localhost:4040");
// production
// const socket = io.connect();

const initialState = {
  type: "",
  email: "",
  team: "",
  agency_district: "",
  name: "",
  brand_name: "",
  agency_name: "",
  client_name: "",
  client_mobile: "",
  client_email: "",
  client_gst: "",
  client_business_name: "",
  business_category: "",
  office_location: "",
  ad_location_district: "",
  ad_location_mandal: "",
  ad_unit: "",
  position: "",
  ad_format: "",
  campaign_mode: "",
  ro_value: "",
  cpc_cpm_cost: "",
  payment_type: "",
  transaction_id: "",
  comments: "",
  agency_commission: "",
  package_details: "",
  credit_period: "",
  content_reference: "",   // only for TamilNadu
  client_info: "",
  start_date: "",
  end_date: "",
  target_location: "",
  campaign_objective: "",
  rofile_url: "",


  // ad_cost: "",
};

let initialValues = JSON.parse(JSON.stringify(initialState));


const googleFormSchema = Yup.object().shape({
  type: Yup.string().required("Type is Required"),
  email: Yup.string().email().required("Email is required"),
  team: Yup.string().required('Team is required'),
  name: Yup.string().required('Your Name is required'),
  brand_name: Yup.string().required('Brand Name is required'),
  agency_name: Yup.string().required('Agency Name is required'),
  client_name: Yup.string().required('Client Name is required'),
  client_mobile: Yup.string()
    .matches(/^[6-9]\d{9}$/, "Invalid Mobile number")
    .min(10, "Mobile must be 10 digits")
    .max(10, "Mobile must be 10 digits")
    .required("Mobile Number is required"),
  client_email: Yup.string().email().required('Client Email is required'),
  client_gst: Yup.string()
    .matches(
      /[0-9]{2}[A-Z]{5}[0-9]{4}[A-z][0-9][Z][0-9]/,
      "Invalid GST number - case sensitive "
    ).required('Client GST is required'),
  client_business_name: Yup.string().required('Client Business Name is required'),
  business_category: Yup.string().required('Business Category is required'),
  office_location: Yup.string().required('Office Location is required'),
  ad_location_district: Yup.string().required('Ad Location : District is required'),
  ad_location_mandal: Yup.string().optional(),
  ad_unit: Yup.string().required('Ad Unit is required'),
  position: Yup.string().required('Position is required'),
  ad_format: Yup.string().required('Ad Format is required'),
  campaign_mode: Yup.string().required('Mode of Campaign is required'),
  start_date: Yup.date().required("Start Date is reqired"),
  end_date: Yup.date()
    .required("End Date is required")
    .min(Yup.ref("start_date"), "End date can't be before Start date"),
  ro_value: Yup.number().positive().required("RO Value is required!"),
  cpc_cpm_cost: Yup.number().positive().optional(),
  payment_type: Yup.string().required('Payment Type  is required'),
  transaction_id: Yup.string().required('Transaction Id is required'),
  comments: Yup.string().optional(),
  agency_commission: Yup.number().positive().required('Agency Commission is required'),
  package_details: Yup.string().required('Package Details are required'),
  credit_period: Yup.date().required("Credit Period is reqired"),
  content_reference: Yup.string().required('Content Reference is required'),   // only for TamilNadu
  client_info: Yup.string().required('Client Info is required'),
  target_location: Yup.string().required('target Location is required'),
  campaign_objective: Yup.string().required('Campaign objective is required'),
  rofile_url: Yup.string().optional().nullable(),
});


function GoogleForms() {

  const navigate = useNavigate();

  const [submit, setSubmit] = useState(false);
  const [validationSchema, setValidationSchema] = useState({});
  const [progress, setProgress] = useState(0);
  const [file, setFile] = useState();
  const [fileUrl, setFileUrl] = useState("");


  const nationlTeams = [  // Add common validation rules for all fields

    { label: "Delhi", value: "delhi" },
    { label: "Mumbai", value: "mumbai" },
    { label: "Banglore", value: "banglore" },
    { label: "Hyderabad", value: "hyderabad" },
    { label: "Existing", value: "existing" }
  ];

  const nationalTeamMembers = [
    { label: "Divya (Hyderabad)", value: "divya_hyd" },
    { label: "Kinjalk (Hyderabad)", value: "kinjalk_hyd" },
    { label: "komal (Hyderabad)", value: "komal_hyd" },
    { label: "Syamala (Hyderabad)", value: "syamala_hyd" },
    { label: "Venakatesh (Hyderabad)", value: "venkatesh_hyd" },
    { label: "Rajnandhan (Delhi)", value: "rajnandhan_delhi" },
    { label: "Shashank (Delhi)", value: "shashank_delhi" },
    { label: "Shriya (Delhi)", value: "shriya_delhi" },
    { label: "Sudeep (Delhi)", value: "sudeep_delhi" },
    { label: "Viswajit (Delhi)", value: "viswajit_delhi" },
    { label: "Alston (Mumbai)", value: "alston_mumbai" },
    { label: "Faraz (Mumbai)", value: "faraz_mumbai" },
    { label: "Naveen (Banglore)", value: "naveen_bnglr" },
    { label: "Raghu", value: "raghu" },
    { label: "Nitin", value: "nitin" },
    { label: "Sri Ram", value: "sri_ram" },
    { label: "Venkatesh (Banglore)", value: "venkatesh" },
    { label: "Manjusha (Banglore)", value: "manjusha_bnglr" },
    { label: "Anita (Mumbai)", value: "anita_mumbai" },
    { label: "Chandan (Mumbai)", value: "chandan_mumbai" },
    { label: "Avinash (Banglore)", value: "avinash-bnglr" },
    { label: "Lalit (Mumbai)", value: "lalit_mumbai" },
    { label: "Shreya Batra (Delhi)", value: "shreya_batra_delhi" }
  ]

  const nationalAdFormats = [
    { label: "Promoted Story Ad", value: "promted_story_ad" },
    { label: "Full Page Display", value: "full_page_display" },
    { label: "Video Inventory", value: "video_inventory" },
    { label: "Innovation", value: "inovation" },
  ]

  const nationalCampaignModes = [
    { label: "CPM", value: "cpm" },
    { label: "CPC", value: "cpc" }

  ]

  const localTeams = [
    { label: "Metro Sales", value: "metro_sales" },
    { label: "Local Sales", value: "local_sales" },
    { label: "Inbound Sales", value: "inbound_sales" },
    { label: "Panel", value: "panel" }
  ];

  const localTeamMembers = [
    { label: "Hyderabad - Raghu (LS01)", value: "raghu_hyd" },
    { label: "Hyderabad - KC (LS02)", value: "kc_hyd" },
    { label: "Hyderabad - Shanthi (IS01)", value: "shanthi_hyd" },
    { label: "Hyderabad - Sameena (IS02)", value: "sameena_hyd" },
    { label: "Hyderabad - Srinivas (IS03)", value: "srinivas_hyd" },
    { label: "Hyderabad - Gourav (IS04)", value: "gourav_hyd" },
    { label: "Hyderabad - Syamala (OS01)", value: "syamala_hyd" },
    { label: "Hyderabad - Sai Charan (MS01)", value: "sai_charan_hyd" },
    { label: "Hyderabad - Venkaat Subba Rao (MS02)", value: "subba_rao_hyd" },
    { label: "Hyderabad - Sai Bhaskar (MS03)", value: "sai_bhaskar_hyd" },
    { label: "Hyderabad - Madhu Sudhan (MS04)", value: "madhusudhan__hyd" },
    { label: "Hyderabad - Maanas (MS05)", value: "maanas_hyd" },
    { label: "Hyderabad - Hemavathi (MS06)", value: "hemavathi_hyd" },
    { label: "Hyderabad - YS Kumar (MS07)", value: "kumar_hyd" },
    { label: "Hyderabad - Balaraj (MS08)", value: "balaraj_hyd" },
    { label: "Hyderabad - BS Bhaskar (MS09)", value: "bs_bhaskar_hyd" },
    { label: "Hyderabad - Bhaskar Rao (MZ01)", value: "bhaskar_rao__hyd" },
    { label: "Srikakulam - Appalaraju (DS01)", value: "appalaraju_sklm" },
    { label: "Vizianagaram - Prasada Rao (DS02)", value: "prasada_rao_vzm" },
    { label: "Vizag - BV Prasad (DS03)", value: "bv_prasad_vzg" },
    { label: "Vizag - Adinarayana (DS04)", value: "adinarayana_vzg" },
    { label: "East Godavari - GVS Raju (DS05)", value: "gvs_raju_east_gd" },
    { label: "West Godavari - Rama Krishna (DS06)", value: "rama_krishna_west_gd" },
    { label: "Vijayawada - Hari Krishna (DS07)", value: "hari_krishna_vja" },
    { label: "prakasam - Rajesh (DS08)", value: "rajesh_praksam" },
    { label: "Chittoor - Naveen (DS10)", value: "naveen_cto" },
    { label: "Anantapur - Siva Prasad (DS011)", value: "siva_prasad_atp" },
    { label: "Kurnool - Mastan Hussain (DS12)", value: "mastan_hussain_knl" },
    { label: "Y.S.R.(Cuddapah) - Venkata Sivaiah (DS13)", value: "venkata-sivaiah_cuddapah" },
    { label: "Warangal - Naresh Kumar (DS14)", value: "naresh_kumar_wl" },
    { label: "Khammam - Naveen (DS15)", value: "naveen_khammam" },
    { label: "Nalgonda - Anand (DS16)", value: "anand_nlda" },
    { label: "Hyderabad - Siva Sankaraiah (DS17)", value: "siva_sankaraiah_hyd" },
    { label: "Vijayawada - M V R K Kishore (DS18)", value: "m_v_r_k_kishore_vja" },
    { label: "Guntur - Sivaji Ganesh (DS19)", value: "sivaji_ganesh_gnt" },
    { label: "Nellore - Mahendra (DS20)", value: "mahendra_nlr" },
    { label: "Panel", value: "panel" }
  ]

  const businesscategories = [
    { label: "Retail", value: "retail" },
    { label: "Realestate and Construction", value: "realestate" },
    { label: "Healthcare and Hospitals", value: "healthcare" },
    { label: "Education and Careers", value: "education" },
    { label: "Automobiles Travel Transport", value: "automobiles_travel" },
    { label: "BFSI", value: "bfsi" },
    { label: "Services        ", value: "services" },
    { label: "Consumer Durables, Electronics & Mobiles", value: "consumer_durables" },
    { label: "Govt PSU's", value: "psus" },
    { label: "Personal", value: "personal" },
    { label: "FMCG", value: "fmcg" },
    { label: "Other", value: "other" },
  ]

  const adUnits = [
    { label: "Mandal", value: "mandal" },
    { label: "District", value: "district" },
    { label: "State", value: "state" },
    { label: "CPM", value: "cpm" },
    { label: "Multiple Mandals", value: "multiple_mandals" },
    { label: "Multiple Districts", value: "multiple_districts" },

  ]

  const adFormats = [
    { label: "Promoted Story", value: "promoted_story" },
    { label: "Promoted Gallery", value: "promoted_gallery" },
    { label: "Promoted Video", value: "promoted_video" },
    { label: "Full Page", value: "full_page" },
    { label: "Full Page Video", value: "full_page_video" },
    { label: "Full Page Video (Image + Video)", value: "full_page_video_image" },
    { label: "Full Page Gallery", value: "full_page_gallery" },
    { label: "Magazine - Half page", value: "magazine_half_page" },
    { label: "Sponsered Magazine", value: "sponsored_magazine" },
    { label: "Exclusive Magazine", value: "exclusive_magazine" },
    { label: "Classified Ads", value: "classified_ads" },
    { label: "Sponsored News Article (Logo Insertion)", value: "sponsored_news_article" },
    { label: "Sponsored Share Card", value: "sponsored_share_card" },
    { label: "Sponsored Video(logo Insertion before the video)", value: "sponsored_video" },
    { label: "Strip Ad", value: "strip_ad" },
    { label: "Sponsored Score Card", value: "sponsored_score_card" },
    { label: "Sponsored Video Interview", value: "sponsored_video_interview" },
    { label: "Others", value: "others" },
  ]

  const tamilTeamMembers = [
    { label: "Naveen Kumar R", value: "naveen_kumar_r" },
    { label: "Mohan Kumar", value: "mohan_kumar" },
    { label: "Deepthi Shyam", value: "deepthi_shyam" },
    { label: "Prashant R", value: "prashant_r" }
  ];

  const positions = [
    { label: "1", value: "1" },
    { label: "2-3", value: "2-3" },
    { label: "4-5", value: "4-5" },
    { label: "6-9", value: "6-9" },
    { label: "11-12", value: "11-12" },
    { label: "16-19", value: "16-19" },
    { label: "21-25", value: "21-25" },
    { label: "26-30", value: "26-30" },
    { label: "31-40", value: "31-40" },
    { label: "41-50", value: "41-50" },
    { label: "21 - 35(For Mandal campaign)", value: "21-35" }
  ]

  const localPaymentMethods = [
    { label: "Prepaid", value: "Prepaid" },
    { label: "Postpaid(RO)", value: "postpaid_ro" },
    { label: "PDC", value: "pdc" },
    { label: "Partial Credit", value: "partail_credit" },
  ]

  const tamilPaymentMethods = [
    { label: "Prepaid", value: "Prepaid" },
    { label: "Postpaid(RO)", value: "postpaid_ro" },
    { label: "PDC", value: "pdc" },
    { label: "Postpaid(Local)", value: "postpaid_local" },
    { label: "Partial Credit", value: "partail_credit" },
  ]

  const commonValidationSchema = {
    type: Yup.string().required("Type is Required"),
    email: Yup.string().email().required("Email is required"),
    team: Yup.string().required('Team is required'),
    name: Yup.string().required('Your Name is required'),
    client_name: Yup.string().required('Client Name is required'),
    client_mobile: Yup.string()
      .matches(/^[6-9]\d{9}$/, "Invalid Mobile number")
      .min(10, "Mobile must be 10 digits")
      .max(10, "Mobile must be 10 digits")
      .required("Mobile Number is required"),
    client_email: Yup.string().email().required('Client Email is required'),
    ad_format: Yup.string().required('Ad Format is required'),
    start_date: Yup.date().required("Start Date is reqired"),
    agency_name: Yup.string().required('Agency Name is required'),

  };

  let formik = useFormik({
    initialValues: JSON.parse(JSON.stringify(initialState)),
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        formik.values.rofile_url = fileUrl;
        let res = await api({
          url: `/adrequest/fill_adReqForm`,
          method: "POST",
          responseType: "json",
          data: values
        });
        if (res?.code !== 200) {
          Toast('error', res?.data?.message);

        } else {
          Toast("success", "Contact Added Successfully");
          resetForm();
          setFile();
          setFileUrl("");
          setSubmit(false);
          setProgress(0)
          initialValues = JSON.parse(JSON.stringify(initialState));
          formik.setValues(initialValues);

        }
      } catch (error) {
        let er = error?.response?.message || "Something went wrong"
        Toast("error", er)
        if (error.response.status === 401)
          navigate("/*")
      }

    }
  });

  const formData = new FormData();
  formData.append("files", file);
  const uploadroFile = async () => {
    try {
      let res = await api({
        url: "/adrequest/fill_adReqForm/file-upload",
        method: "POST",
        responseType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (data) => {
          setProgress(Math.round((100 * data.loaded) / data.total));
        },
      });
      if (res.code === 200) {
        setFileUrl(res.data);
        setFile("");
        setProgress(0);
        Toast("success", "File uploaded successfully");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleFileChange = (e, url) => {
    if (e.target.files.length) {
      if (e.target.files[0].type === "application/pdf") {
        setFile(e.target.files[0]);
      } else {
        Toast("error", "Only pdf formats accepted");
        document.getElementById("ro_file").value = "";
        formik.setFieldValue("rofile_url", "");
      }
    } else {

      setFileUrl("");

    }
  };

  useEffect(() => {
    const buildValidationSchema = (type) => {
      let specificValidationSchema = {};
      let localSchema = {
        client_gst: Yup.string()
          .matches(
            /[0-9]{2}[A-Z]{5}[0-9]{4}[A-z][0-9][Z][0-9]/,
            "Invalid GST number - case sensitive "
          ).required('Client GST is required'),
        client_business_name: Yup.string().required('Client Business Name is required'),
        business_category: Yup.string().required('Business Category is required'),
        office_location: Yup.string().required('Office Location is required'),
        ad_location_district: Yup.string().required('Ad Location : District is required'),
        ad_location_mandal: Yup.string().optional(),
        ad_unit: Yup.string().required('Ad Unit is required'),
        position: Yup.string().required('Position is required'),
        payment_type: Yup.string().required('Payment Type  is required'),
        transaction_id: Yup.string().required('Transaction Id is required'),
        comments: Yup.string().optional(),
        agency_commission: Yup.string().required('Agency Commission is required'),
        package_details: Yup.string().required('Package Details are required'),
        credit_period: Yup.date().optional(),
        client_info: Yup.string().required('Client Info is required'),
        cpc_cpm_cost: Yup.number().positive().required('Ad Cost is required'),
      }

      if (formik.values.type === 'National') {
        specificValidationSchema = {
          brand_name: Yup.string().required('Brand Name is required'),
          campaign_mode: Yup.string().required('Mode of Campaign is required'),
          ro_value: Yup.number().positive().required("RO Value is required!"),
          end_date: Yup.date()
            .required("End Date is required")
            .min(Yup.ref("start_date"), "End date can't be before Start date"),
          target_location: Yup.string().required('Target Location is required'),
          campaign_objective: Yup.string().required('Campaign Objective is required'),
          rofile_url: Yup.string().required('RO File is required'),
          cpc_cpm_cost: Yup.number().positive().optional(),
        };
      } else if (formik.values.type === 'Local') {
        specificValidationSchema = { ...localSchema }
      } else if (formik.values.type === 'TamilNadu') {
        specificValidationSchema = {
          ...localSchema,
          agency_district: Yup.string().required('Agency District is required'),  // only for TamilNadu
          content_reference: Yup.string().required('Content Reference is required'),   // only for TamilNadu
        }
      }
      return Yup.object().shape({ ...commonValidationSchema, ...specificValidationSchema });
    };

    const validationSchema = buildValidationSchema(formik.values.type);

    setValidationSchema(validationSchema);
  }, [formik.values.type]);

  useEffect(() => {
    if (file) uploadroFile();
  }, [file]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="adRequestLogo">
        <img src={Way2NewsLogo} alt="image" />
        <h1>{formik.values.type === 'National' ? 'Way2News: Campaign Execution Form ' : 'Way2News: Ad Request Form'}</h1>
        <h6>
          {formik.values.type === 'National' ? 'Note: Campaign Creatives, Tracking Links & Any Campaign Execution sheets should be shared to ops Mail.Mail ID: ops@way2news.co For urgent requirements, pls call Nitin : 736977595 ' : ((formik.values.type === 'Local' || formik.values.type === 'TamilNadu') ? 'For Urgent Requirements, Pls Call Vamshi: 73311 49144' : null)}
        </h6>
      </div>
      <div className="GoogleForms">
        {/* Type */}
        <div className="mb-3">
          <label className="mb-1"> Select Type </label><span className="text-red-600">*</span>
          <select
            className="form-select"
            aria-label="Default select example"
            name="type"
            placeholder="Select Type"
            onBlur={formik.handleBlur}
            value={formik.values.type}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          >
            <option value="0">Select Type (National/Local/TamilNadu)</option>
            <option value="National">National</option>
            <option value="Local">Local</option>
            <option value="TamilNadu">TamilNadu</option>
          </select>
          {submit && formik.errors.type ? (
            <div className="text-red-600	">{formik.errors.type}</div>
          ) : null}
        </div>

        {/* Email */}
        <div className="mb-3" >
          <label className="mb-1">Email</label><span className="text-red-600">*</span>
          <input
            type='email'
            className="form-control"
            placeholder='Enter Email'
            name='email'
            aria-label=""
            value={formik.values.email}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {submit && formik.errors.email ? (
            <div className="text-red-600 ">{formik.errors.email}</div>
          ) : null}
        </div>

        {/* Team */}
        <div className="mb-3">
          <label>{formik.values.type === 'National' ? 'Location' : 'Team'}</label><span className="text-red-600">*</span>
          <select
            className="form-select"
            aria-label="Default select example"
            name="team"
            placeholder="Select Team"
            onBlur={formik.handleBlur}
            value={formik.values.team}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          >
            <option value="">Select Your Team</option>
            {formik.values.type === 'National' && nationlTeams.map((item) => {
              return (<option value={item.label} key={item.value}>
                {item.label}
              </option>
              );
            })}
            {formik.values.type === 'Local' && localTeams.map((item) => {
              return (<option value={item.label} key={item.value}>
                {item.label}
              </option>
              );
            })}
            {formik.values.type === 'TamilNadu' && (
              <>
                <option value="Metro Sales (Tamil Nadu)">Metro Sales (Tamil Nadu)</option>
                <option value="Local Sales (Tamil Nadu)">Local Sales (Tamil Nadu)</option>
              </>
            )}

          </select>



          {submit && formik.errors.team ? (
            <div className="text-red-600	">
              {formik.errors.team}
            </div>
          ) : null}
        </div>

        {/* Agency District */}
        {formik.values.type === "TamilNadu" ? <div className="mb-3">
          <label>Agency District</label><span className="text-red-600">*</span>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Agency District"
            aria-label=""
            name="agency_district"
            value={formik.values.agency_district}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {submit && formik.errors.agency_district ? (
            <div className="text-red-600 ">{formik.errors.agency_district}</div>
          ) : null}
        </div> : null}

        {/*Your Name */}
        <div className="mb-3">
          <label>Your Name</label><span className="text-red-600">*</span>
          <select
            className="form-select"
            aria-label="Default select example"
            name="name"
            placeholder="Select your Name"
            onBlur={formik.handleBlur}
            value={formik.values.name}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          >
            <option value="">Select Your Name</option>
            {formik.values.type === 'National' && nationalTeamMembers.map((item) => {
              return (<option value={item.label} key={item.value}>
                {item.label}
              </option>
              );
            })}
            {formik.values.type === 'Local' && localTeamMembers.map((item) => {
              return (<option value={item.label} key={item.value}>
                {item.label}
              </option>
              );
            })}
            {formik.values.type === 'TamilNadu' && tamilTeamMembers.map((item) => {
              return (<option value={item.label} key={item.value}>
                {item.label}
              </option>
              );
            })}
          </select>
          {submit && formik.errors.name ? (
            <div className="text-red-600	">
              {formik.errors.name}
            </div>
          ) : null}
        </div>

        {/* Brand Name */}
        {formik.values.type === "National" ? <div className="mb-3">
          <label >Brand Name</label><span className="text-red-600">*</span>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Brand Name"
            aria-label=""
            name="brand_name"
            value={formik.values.brand_name}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {submit && formik.errors.brand_name ? (
            <div className="text-red-600 ">{formik.errors.brand_name}</div>
          ) : null}
        </div> : null}

        {/* Agency Name */}
        {formik.values.type === "National" ? <div className="mb-3">
          <label>Agency Name</label><span className="text-red-600">*</span>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Agency Name"
            aria-label=""
            name="agency_name"
            value={formik.values.agency_name}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {submit && formik.errors.agency_name ? (
            <div className="text-red-600 ">{formik.errors.agency_name}</div>
          ) : null}
        </div> : null}

        {/*Client Name*/}
        <div className="mb-3">
          <label>{formik.values.type === 'National' ? 'Client End POC (Name)' : 'Client Name'}</label><span className="text-red-600">*</span>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Client Name"
            aria-label=""
            name="client_name"
            value={formik.values.client_name}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {submit && formik.errors.client_name ? (
            <div className="text-red-600 ">{formik.errors.client_name}</div>
          ) : null}
        </div>

        {/*Client mobile Num*/}
        <div className="mb-3" >
          <label>{formik.values.type === 'National' ? 'Client End POC - Mobile Number ' : 'Client Contact Number'}</label><span className="text-red-600">*</span>
          <input
            className="form-control"
            type='tel'
            name='client_mobile'
            placeholder='Enter Mobile No'
            aria-label=""
            value={formik.values.client_mobile}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {submit && formik.errors.client_mobile ? (
            <div className="text-red-600 ">{formik.errors.client_mobile}</div>
          ) : null}
        </div>

        {/* Client Email */}
        <div className="mb-3" >
          <label>{formik.values.type === 'National' ? 'Client End POC - Mail Id ' : 'Client Email Id'}</label><span className="text-red-600">*</span>
          <input
            type='email'
            className="form-control"
            placeholder='Enter Email'
            name='client_email'
            aria-label=""
            value={formik.values.client_email}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {submit && formik.errors.client_email ? (
            <div className="text-red-600 ">{formik.errors.client_email}</div>
          ) : null}
        </div>

        {/* Client GST */}
        {(formik.values.type === "Local") ? <div className="mb-3" >
          <label>Client GST No./ Unregistered </label><span className="text-red-600">*</span>
          <input
            type='text'
            className="form-control"
            placeholder='Enter Client GST No'
            name='client_gst'
            aria-label=""
            value={formik.values.client_gst}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {submit && formik.errors.client_gst ? (
            <div className="text-red-600 ">{formik.errors.client_gst}</div>
          ) : null}
        </div> : null}

        {/* Client Agency Name */}
        {(formik.values.type === "Local" || formik.values.type === "TamilNadu") ? <div className="mb-3" >
          <label>Client Agency Name </label><span className="text-red-600">*</span>
          <input
            type='text'
            className="form-control"
            placeholder='Enter Client Agency Name'
            name='agency_name'
            aria-label=""
            value={formik.values.agency_name}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {submit && formik.errors.agency_name ? (
            <div className="text-red-600 ">{formik.errors.agency_name}</div>
          ) : null}
        </div> : null}

        {/* Client Business Name */}
        {(formik.values.type === "Local" || formik.values.type === "TamilNadu") ? <div className="mb-3" >
          <label>Client Business Name </label><span className="text-red-600">*</span>
          <input
            type='text'
            className="form-control"
            placeholder='Enter Client Business Name'
            name='client_business_name'
            aria-label=""
            value={formik.values.client_business_name}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {submit && formik.errors.client_business_name ? (
            <div className="text-red-600 ">{formik.errors.client_business_name}</div>
          ) : null}
        </div> : null}

        {/* Client Business Category */}
        {(formik.values.type === "Local" || formik.values.type === "TamilNadu") ? < div className="mb-3">
          <label>Client Business Category</label><span className="text-red-600">*</span>
          <select
            className="form-select"
            aria-label="Default select example"
            name="business_category"
            placeholder="Select Business Category"
            onBlur={formik.handleBlur}
            value={formik.values.business_category}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          >
            <option value="">Select Business Category</option>
            {businesscategories.map((item) => {
              return (
                <option value={item.label} key={item.value}>
                  {item.label}
                </option>
              );
            })}
          </select>
          {submit && formik.errors.business_category ? (
            <div className="text-red-600	">
              {formik.errors.business_category}
            </div>
          ) : null}
        </div> : null}

        {/*Client office Location*/}
        {(formik.values.type === "Local" || formik.values.type === "TamilNadu") ? <div className="mb-3">
          <label>Client Office Location</label><span className="text-red-600">*</span>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Client Office Location"
            aria-label=""
            name="office_location"
            value={formik.values.office_location}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {submit && formik.errors.office_location ? (
            <div className="text-red-600 ">{formik.errors.office_location}</div>
          ) : null}
        </div> : null}

        {/*Ad Location: District*/}
        {(formik.values.type === "Local" || formik.values.type === "TamilNadu") ? <div className="mb-3">
          <label>Ad Location: District</label><span className="text-red-600">*</span>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Ad Location : District"
            aria-label=""
            name="ad_location_district"
            value={formik.values.ad_location_district}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {submit && formik.errors.ad_location_district ? (
            <div className="text-red-600 ">{formik.errors.ad_location_district}</div>
          ) : null}
        </div> : null}

        {/*Ad Location: Mandal*/}
        {(formik.values.type === "Local" || formik.values.type === "TamilNadu") ? <div className="mb-3">
          <label>Ad Location: Mandal</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Ad Location : Mandal"
            aria-label=""
            name="ad_location_mandal"
            value={formik.values.ad_location_mandal}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {submit && formik.errors.ad_location_mandal ? (
            <div className="text-red-600 ">{formik.errors.ad_location_mandal}</div>
          ) : null}
        </div> : null}

        {/* Ad Unit */}
        {(formik.values.type === "Local" || formik.values.type === "TamilNadu") ? < div className="mb-3">
          <label>Ad Unit</label><span className="text-red-600">*</span>
          <select
            className="form-select"
            aria-label="Default select example"
            name="ad_unit"
            placeholder="Select Ad Unit"
            onBlur={formik.handleBlur}
            value={formik.values.ad_unit}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          >
            <option value="">Select Ad unit</option>
            {adUnits.map((item) => {
              return (
                <option value={item.label} key={item.value}>
                  {item.label}
                </option>
              );
            })}
          </select>
          {submit && formik.errors.ad_unit ? (
            <div className="text-red-600	">
              {formik.errors.ad_unit}
            </div>
          ) : null}
        </div> : null}

        {/* Position */}
        {(formik.values.type === "Local" || formik.values.type === "TamilNadu") ? < div className="mb-3">
          <label>Position</label><span className="text-red-600">*</span>
          <select
            className="form-select"
            aria-label="Default select example"
            name="position"
            placeholder="Select Position"
            onBlur={formik.handleBlur}
            value={formik.values.position}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          >
            <option value="">Select Position</option>
            {positions.map((item) => {
              return (
                <option value={item.label} key={item.value}>
                  {item.label}
                </option>
              );
            })}
          </select>
          {submit && formik.errors.position ? (
            <div className="text-red-600	">
              {formik.errors.position}
            </div>
          ) : null}
        </div> : null}

        {/*Ad Format */}
        <div className="mb-3">
          <label>Ad Format</label><span className="text-red-600">*</span>
          <select
            className="form-select"
            aria-label="Default select example"
            name="ad_format"
            placeholder="Select your Ad Format"
            onBlur={formik.handleBlur}
            value={formik.values.ad_format}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          >
            <option value="">Select Ad format</option>
            {formik.values.type === 'National' && nationalAdFormats.map((item) => {
              return (<option value={item.label} key={item.value}>
                {item.label}
              </option>
              );
            })}
            {formik.values.type === 'Local' && adFormats.map((item) => {
              return (<option value={item.label} key={item.value}>
                {item.label}
              </option>
              );
            })}
            {formik.values.type === 'TamilNadu' && adFormats.map((item) => {
              return (<option value={item.label} key={item.value}>
                {item.label}
              </option>
              );
            })}
          </select>
          {submit && formik.errors.ad_format ? (
            <div className="text-red-600	">
              {formik.errors.ad_format}
            </div>
          ) : null}
        </div>

        {/*Mode Of Campaign*/}
        {formik.values.type === "National" ? < div className="mb-3">
          <label>Mode of Campaign</label><span className="text-red-600">*</span>
          <select
            className="form-select"
            aria-label="Default select example"
            name="campaign_mode"
            placeholder="Select Mode of Campaign"
            onBlur={formik.handleBlur}
            value={formik.values.campaign_mode}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          >
            <option value="">Select Mode of Campaign</option>
            {nationalCampaignModes.map((item) => {
              return (
                <option value={item.label} key={item.value}>
                  {item.label}
                </option>
              );
            })}
          </select>
          {submit && formik.errors.campaign_mode ? (
            <div className="text-red-600	">
              {formik.errors.campaign_mode}
            </div>
          ) : null}
        </div> : null}

        {/*RO Value*/}
        {formik.values.type === "National" ? < div className="mb-3">
          <label>RO Value</label><span className="text-red-600">*</span>
          <input
            type='number'
            className="form-control"
            placeholder='Enter RO Value'
            name='ro_value'
            aria-label=""
            value={formik.values.ro_value}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {submit && formik.errors.ro_value ? (
            <div className="text-red-600 ">{formik.errors.ro_value}</div>
          ) : null}
        </div> : null}

        {/*CPM/CPC or Ad Cost*/}
        < div className="mb-3">
          <label>{formik.values.type === 'National' ? 'CPM / CPC Cost' : (formik.values.type === 'Local' ? 'Ad Cost (Without GST)' : 'Ad Cost')}</label>{['Local', 'TamilNadu'].includes(formik.values.type) ? <span className="text-red-600">*</span> : null}
          <input
            type='number'
            className="form-control"
            placeholder={formik.values.type === 'National' ? 'Enter CPM/CPC Cost' : (formik.values.type === 'Local' ? 'Enter Ad Cost without GST' : 'Enter Ad Cost')}
            name='cpc_cpm_cost'
            aria-label=""
            value={formik.values.cpc_cpm_cost}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {submit && formik.errors.cpc_cpm_cost ? (
            <div className="text-red-600 ">{formik.errors.cpc_cpm_cost}</div>
          ) : null}
        </div>

        {/* Payment Type */}
        {(formik.values.type === "Local" || formik.values.type === "TamilNadu") ? < div className="mb-3">
          <label>Payment Type</label><span className="text-red-600">*</span>
          <select
            className="form-select"
            aria-label="Default select example"
            name="payment_type"
            placeholder="Select Payment Type"
            onBlur={formik.handleBlur}
            value={formik.values.payment_type}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          >
            <option value="">Select Payment Type</option>
            {formik.values.type === 'Local' && localPaymentMethods.map((item) => {
              return (<option value={item.label} key={item.value}>
                {item.label}
              </option>
              );
            })}
            {formik.values.type === 'TamilNadu' && tamilPaymentMethods.map((item) => {
              return (<option value={item.label} key={item.value}>
                {item.label}
              </option>
              );
            })}
          </select>
          {submit && formik.errors.payment_type ? (
            <div className="text-red-600	">
              {formik.errors.payment_type}
            </div>
          ) : null}
        </div> : null}

        {/* Payment / Transaction ID*/}
        {(formik.values.type === "Local" || formik.values.type === "TamilNadu") ? < div className="mb-3">
          <label>Payment / Transaction ID</label><span className="text-red-600">*</span>
          <input
            type='text'
            className="form-control"
            placeholder='Enter Payment / Transaction ID'
            name='transaction_id'
            aria-label=""
            value={formik.values.transaction_id}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {submit && formik.errors.transaction_id ? (
            <div className="text-red-600 ">{formik.errors.transaction_id}</div>
          ) : null}
        </div> : null}

        {/* Comments (Ad details Package details if any, etc)*/}
        {(formik.values.type === "Local" || formik.values.type === "TamilNadu") ? <div className="mb-3">
          <label >Comments</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Comments (Ad details Package details if any, etc)"
            aria-label=""
            name="comments"
            value={formik.values.comments}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {submit && formik.errors.comments ? (
            <div className="text-red-600 ">{formik.errors.comments}</div>
          ) : null}
        </div> : null}

        {/*Agency commission*/}
        {(formik.values.type === "Local" || formik.values.type === "TamilNadu") ? < div className="mb-3">
          <label>{formik.values.type === 'Local' ? 'Agency Commission to be Released(Metro & Local Only)' : (formik.values.type === 'TamilNadu' ? 'Agency Commission to be Released(Metro Only)' : 'Agency Commission')}</label><span className="text-red-600">*</span>
          <select
            className="form-select"
            aria-label="Default select example"
            name="agency_commission"
            placeholder="Select Agency Commission"
            onBlur={formik.handleBlur}
            value={formik.values.agency_commission}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          >
            <option value="">Select Agency Commission</option>
            {formik.values.type === 'Local' && (
              <>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
                <option value="Not Applicable(Inbound)">Not Applicable(Inbound)</option>
              </>
            )}
            {formik.values.type === 'TamilNadu' && (
              <>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
                <option value="Not Applicable(Inside/Local)">Not Applicable(Inside/Local)</option>
              </>
            )}
          </select>
          {submit && formik.errors.agency_commission ? (
            <div className="text-red-600	">
              {formik.errors.agency_commission}
            </div>
          ) : null}
        </div> : null}

        {/*Package/PO/RO Details*/}
        {(formik.values.type === "Local" || formik.values.type === "TamilNadu") ? <div className="mb-3">
          <label >Package/PO/RO Details</label><span className="text-red-600">*</span>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Package/PO/RO Details"
            aria-label=""
            name="package_details"
            value={formik.values.package_details}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {submit && formik.errors.package_details ? (
            <div className="text-red-600 ">{formik.errors.package_details}</div>
          ) : null}
        </div> : null}

        {/*Credit period*/}
        {(formik.values.type === "Local" || formik.values.type === "TamilNadu") ? <div className="mb-3">
          <label>Credit Period</label>
          <input
            type="date"
            name="credit_period"
            className="form-control"
            placeholder="Choose the Credit period"
            aria-label=""
            value={formik.values.credit_period}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {formik.errors.credit_period && formik.touched.credit_period ? (
            <div className="text-red-600">{formik.errors.credit_period}</div>
          ) : null}
        </div> : null}

        {/*Ad Content Reference*/}
        {formik.values.type === "TamilNadu" ? < div className="mb-3">
          <label>Ad Content Reference</label><span className="text-red-600">*</span>
          <select
            className="form-select"
            aria-label="Default select example"
            name="content_reference"
            placeholder="Select Ad Content Reference"
            onBlur={formik.handleBlur}
            value={formik.values.content_reference}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          >
            <option value="">Select Ad Content Reference</option>
            <option value="Content Writer">Content Writer</option>
            <option value="Client">Client</option>
          </select>
          {submit && formik.errors.content_reference ? (
            <div className="text-red-600	">
              {formik.errors.content_reference}
            </div>
          ) : null}
        </div> : null}

        {/*Client Info*/}
        {(formik.values.type === "TamilNadu" || formik.values.type === "Local") ? < div className="mb-3">
          <label>Client Info</label><span className="text-red-600">*</span>
          <select
            className="form-select"
            aria-label="Default select example"
            name="client_info"
            placeholder="Select Client Info"
            onBlur={formik.handleBlur}
            value={formik.values.client_info}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          >
            <option value="">Select Client Info</option>
            <option value="New Client">New Client</option>
            <option value="old Client">old Client</option>
          </select>
          {submit && formik.errors.client_info ? (
            <div className="text-red-600	">
              {formik.errors.client_info}
            </div>
          ) : null}
        </div> : null}

        {/*Ad to be published on for Local&Tamil and Campaign Start Date For National*/}
        <div className="mb-3">
          <label>{(formik.values.type === 'Local' || formik.values.type === "TamilNadu") ? 'Ad to be published on' : 'Campaign Start Date'}</label><span className="text-red-600">*</span>
          <input
            type="date"
            name="start_date"
            className="form-control"
            placeholder=
            {(formik.values.type === 'Local' || formik.values.type === 'TamilNadu') ? 'Choose the date on Ad to publish' : 'Choose Campaign Start Date '}
            aria-label=""
            value={formik.values.start_date}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {formik.errors.start_date && formik.touched.start_date ? (
            <div className="text-red-600">{formik.errors.start_date}</div>
          ) : null}
        </div>

        {/*Campaign End Date for National*/}
        {formik.values.type === "National" ? < div className="mb-3">
          <label>Campaign End Date</label><span className="text-red-600">*</span>
          <input
            type="date"
            name="end_date"
            className="form-control"
            placeholder='Choose Campaign End Date '
            aria-label=""
            value={formik.values.end_date}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {formik.errors.end_date && formik.touched.end_date ? (
            <div className="text-red-600">{formik.errors.end_date}</div>
          ) : null}
        </div> : null}

        {/*Targeting Location for National*/}
        {formik.values.type === "National" ? <div className="mb-3">
          <label >Targeting Location</label><span className="text-red-600">*</span>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Targeting Location"
            aria-label=""
            name="target_location"
            value={formik.values.target_location}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {submit && formik.errors.target_location ? (
            <div className="text-red-600 ">{formik.errors.target_location}</div>
          ) : null}
        </div> : null}

        {/*Ro File for location*/}
        {formik.values.type === "National" ? <div className="mb-3">
          <label className="form-label">Ro File</label>
          <div className="d-flex gap-3">
            <input
              type="file"
              className="form-control"
              aria-label=""
              name="rofile_url"
              id="ro_file"
              accept="application/pdf"
              onChange={(e) => {
                handleFileChange(e);
              }}
            />

            {progress > 0 && progress < 100 ? (
              <SlProgressBar value={progress}>{progress}%</SlProgressBar>
            ) : null
            }
          </div>
          <p>{formik.values.rofile_url || fileUrl || "-"}</p>
          {formik.errors.rofile_url && (
            <p className="text-red-600">{formik.errors.rofile_url}</p>
          )}
        </div> : null}

        {/*Campaign Objective for for national*/}
        {formik.values.type === "National" ? <div className="mb-3">
          <label >Campaign Objective</label><span className="text-red-600">*</span>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Campaign Objective"
            aria-label=""
            name="campaign_objective"
            value={formik.values.campaign_objective}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
            }}
          />
          {submit && formik.errors.campaign_objective ? (
            <div className="text-red-600 ">{formik.errors.campaign_objective}</div>
          ) : null}
        </div> : null}

        <div className="footerBtn">
          <SlButton
            type="submit"
            variant="primary"
            size="small"
            onClick={(e) => setSubmit(true)}>Submit</SlButton>
        </div>
      </div>
    </form >
  )
}
export default GoogleForms